import { getAscendantCodes } from "@l2r-front/l2r-utils"

import { useVerticalSignTypes } from "../queries/verticalSigning/useVerticalSignTypes"

export function useVerticalSignAscendantCodes(code) {
    const { data: verticalSignTypes } = useVerticalSignTypes()

    return getAscendantCodes(code, verticalSignTypes)
}